module.exports = __webpack_public_path__ + "static/bird3-dc35aa9a22a76a8ba1a3d38346c3eb19.png";